import { Grid } from 'antd';

const { useBreakpoint } = Grid;

const AddonBefore = ({ width, external, style = {}, children }) => {
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    // Mobilde geniş label'lar input alanını eziyor — 70px'i geçmesin
    const effectiveWidth = isMobile ? Math.min(width, 70) : width;
    // Mobilde input yüksekliği 38px → addon da aynı olsun ki hizalı dursun
    const minHeight = isMobile ? 38 : undefined;

    if (external) {
        return (
            <div
                className={'ant-input-number-group-addon'}
                style={{
                    width: `${effectiveWidth}px`,
                    minWidth: `${effectiveWidth}px`,
                    minHeight,
                    border: '1px solid #d9d9d9',
                    textAlign: 'start',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: isMobile ? 12 : undefined,
                    padding: isMobile ? '0 6px' : undefined,
                    boxSizing: 'border-box',
                    ...style
                }}
            >
                {children}
            </div>
        )
    }

    return (
        <div
            style={{
                width: effectiveWidth,
                minWidth: effectiveWidth,
                minHeight,
                textAlign: 'start',
                display: isMobile ? 'flex' : undefined,
                alignItems: isMobile ? 'center' : undefined,
                fontSize: isMobile ? 12 : undefined
            }}
        >
            {children}
        </div>
    )
}

export default AddonBefore
